<template>
  <b-container fluid="true" style="margin-left: 0px; width: 100%; border-radius: 30px;">
    <div class="container-fluid" style="width: 100%">
      <b-row style="width: 100%">
        <b-col style="width: 75%">
          <b-row>
            <ul class="activeClass('poo');" :style="displayType(1)" :id="toIdString(menu.name)">
              <draggable
                  @start="drag=true"
                  :list="menu.items"
                  style="width: 100%; margin-bottom: 5px"
                  group="coreQuestions"
                  @end="onEnd" handle=".handle">
                <li v-for="member in menu.items" :key="member.id" :class="getLineItemClass(member.name)"
                    :id="member.name+'-li'">
                  <VineyardMenuItemV2Editor :section="member.name" :value="member" :key="member.id"
                                            :top-level-parent="[menu.name]"/>
                </li>
              </draggable>
            </ul>
          </b-row>
        </b-col>
      </b-row>
    </div>
  </b-container>
</template>

<script>
import VineyardMenuItemV2Editor from "@/components/vineyard/editor/VineyardMenuItemV2Editor.vue";
import Bus from "@/eventBus";
import Swal from "sweetalert2";
import VineyardSurveyPageEditor from "@/components/vineyard/editor/VineyardSurveyPageEditor";

Array.prototype.groupBy = function (prop) {
  return this.reduce(function (groups, item) {
    const val = item[prop];
    groups[val] = groups[val] || [];
    groups[val].push(item);
    return groups
  }, {})
}
export default {
  name: "MenuEditor",
  components: {
    VineyardSurveyPageEditor,
    'VineyardMenuItemV2Editor': VineyardMenuItemV2Editor
  },
  data() {
    return {
      id: "",
      menuCols: ["top"],
      groupId: "5dda0499177d91260f73f33d",
      editMode: true,
      pageId: '604d8e8c5ab57defd566b6df',
      // Data required for conflict resolution.
      currentResolutionQuestion: "",
      currentResolutionNumber: 1,
      theirResponse: '',
      myResponse: '',
      selectedResponse: '',
      //checkboxMine: '',
      //checkboxTheirs: '',
      //patchMap: {},
      resolutionMap: {},
      modalSaveDisabled: true,
      nextButtonDisabled: false,
      patchResponseMap: new Map(),
      checklistMeta: {},
      menu: {}
    }
  },
  created() {
    Bus.$on('vineyard-page-update', this.changeVineyardSurveyPage);
    Bus.$on('measure-answer-update', this.updateAnswer);
  },
  beforeDestroy() {
    Bus.$off('vineyard-pageUpdate', this.changeVineyardSurveyPage);
    Bus.$off('measure-answer-update', this.updateAnswer);
  },
  methods: {
    refName: function (name) {
      return 'poo' + name;
    },
    addColumn: function () {
      this.menuCols.push('nameTwo');
      console.log("add Name Two")
    },
    saveCheckBoxAsString: function (responseData) {
      Object.entries(responseData).map((value, key) => {
        if (Array.isArray(value[1])) {
          responseData[value[0]] = JSON.stringify(value[1]);
        }
      })
      return responseData;
    },
    unwindJsonToCheckBox: function (responseData) {
      Object.entries(responseData).map((value, key) => {
        if (typeof value[1] === "string" && value[1].startsWith("[") && value[1].endsWith("]")) {
          let valueObject = JSON.parse(value[1]);
          console.log("Parsed Value Object");
          console.log(valueObject)
          responseData[value[0]] = valueObject;
        }
      });
      return responseData;
    },
    saveAction: function () {
      this.patchResponseMap.set(this.currentResolutionQuestion, this.selectedResponse);
      let self = this;

      let patchResponseList = {};
      this.patchResponseMap.forEach((value, key) => {
        patchResponseList[key] = value;
      });

      let surveyResponse = {
        _id: self.surveyResponseId,
        surveyKey: self.survey.surveyKey,
        responsesMap: self.patchResponseMap,
        lastUpdated: self.lastUpdatedDate,
        lastUpdatedBy: localStorage.getItem('user'),
        patchResponseMap: patchResponseList,
        groupId: self.myGroupId
      };
      this.$http.patch("survey", surveyResponse, {
        headers: {
          'content-type': 'application/json'
        }
      })
          .then(returnVal => {
            if (returnVal.data.saved === true) {
              Swal.fire({
                title: 'Survey Saved',
                text: 'Your Survey Has Been Save Successfully.',
                icon: 'success'
              });
              this.loadSurvey();
              this.patchResponseMap = new Map();
              this.currentResolutionQuestion = '';
              this.currentResolutionNumber = 1;
            } else {
              Swal.fire({
                title: 'Survey Save Failed',
                text: 'There was an error while saving.',
                icon: 'error'
              });
            }

          }).catch(error => {
        Swal.fire({
          title: 'Survey Save Failed',
          text: `There was an error while saving. Error: ${error.message}`,
          icon: 'error'
        });
      });
      this.$bvModal.hide("modal-1");
    },
    highlightSection: function (name) {
      this.closeAllSubmenus();
      this.unhighlightAllMenuItem(name);
      this.highlightMenuItem(this.topParent[0]);
      document.getElementById(this.toIdString(name)).style.display = "initial";
      document.getElementById(this.toIdString(name)).style.display = "inline";
      this.topParent.forEach(parent => {
        document.getElementById(this.toIdString(parent)).style.display = "initial";
        document.getElementById(this.toIdString(parent)).style.display = "inline";
      });
    },
    useOriginal: function (color) {
      let shouldUseOriginal = color.length === 0;
      console.log("Should use original: " + shouldUseOriginal);
      return shouldUseOriginal;
    },
    getListStyle: function (topLevel) {
      if (topLevel === true) {
        return "list-style-type: disc";
      } else {
        return "list-style-type: none";
      }
    },
    showIcon: function (iconName) {
      if (iconName) {
        return true;
      } else {
        return false;
      }
    },
    capitalize: function (str) {
      if (str.length === 0) return str;
      return str[0].toUpperCase() + str.substr(1);
    },

    titleCase: function (str) {
      //console.log("The string to Title Case: [" + str + "]");
      str = str.toLowerCase();
      return str.split(' ').map(this.capitalize).join(' ');
    },
    activeClass: function (...names) {
      for (let name of names) {
        if (name === this.$route.name)
          return 'sub-menu active';
      }
      return 'sub-menu';
    },
    getMenuItemClass: function (menuItemName) {
      console.log(`Menu Item Name: ${menuItemName}`);
      let classVal = "d-inline " + menuItemName.toLowerCase()
          .replace(',', '')
          .replace(')', '')
          .replace('/', '-')
          .replace('_', '-')
          .replace('&', 'and');
      console.log(`Menu Item Name  Converted: ${classVal}`);
      return classVal;
    },
    getProgressBarClass: function (sectionName) {
      return "progress-bar progress-background " + sectionName.toLowerCase() + "_progress";
    },
    getClassType: function (groupName) {
      console.log(`Group Name: ${groupName}`);
      return groupName.toLowerCase().replace(/_/g, "-")
          .replace(/\//g, '-')
          .replace(/,/g, '-')
          .replace(/&/g, '-') + "-group nav-item";
    },
    getLineItemClass: function (sectionName) {
      return "default-line-item";
    },
    getLineItemLinkClass: function (sectionName) {
      return "ajax " + sectionName.toLowerCase() + "-line-item";
    },
    toIdString: function (idCandidate) {
      return idCandidate.toUpperCase()
          .replace(" ", "_")
          .replace("/\//g", "_");
    },
    displayType: function (...names) {
      for (let name of names) {
        if (name === this.$route.name)
          return 'list-style-type: none; font-family: Montserrat, sans-serif; padding-right: 0px; padding-left 5px';
      }
      //return 'display: none; list-style-type: none; color: black; font-family: Montserrat, sans-serif; padding-right: 0px;';
      return 'list-style-type: none; color: black; font-family: Montserrat, sans-serif; padding-right: 0px; padding-left 5px';
    },
    triggerMessage: function (pageName) {
      document.getElementById(pageName).style.display = "initial";
    },
    closeAllSubmenus: function () {
      let submenus = document.querySelectorAll(".sub-menu");
      submenus.forEach(val => {
        val.style.display = "none";
      });
    },
    highlightMenuItem: function (section) {
      console.log(`Section Clicked: ${section}`);
      let selector = "." + section.toLowerCase()
              .replace(/_/g, "-")
              .replace(/,/g, "-")
              .replace(/\//g, "-")
          + "-group";
      console.log(`Selector: ${selector}`);
      let menuBlock = document.querySelector(selector);
      menuBlock.style.backgroundColor = "white";

    },
    unhighlightAllMenuItem: function (section) {
      let menuBlocks = document.querySelectorAll("li[class$='-group nav-item']");
      if (menuBlocks.length > 0) {
        menuBlocks.forEach(val => {
          val.style.backgroundColor = "transparent";
        });
      }

    },
    tabClick(tab, item) {
      if (this.$route.name === "Vineyard Page" || this.$route.name === "Vineyard Page Editor") {
        this.closeAllSubmenus();
        this.unhighlightAllMenuItem(tab);
        this.highlightMenuItem(this.topParent[0]);
        document.getElementById(this.toIdString(tab)).style.display = "initial";
        document.getElementById(this.toIdString(tab)).style.display = "inline";
        this.topParent.forEach(parent => {
          document.getElementById(this.toIdString(parent)).style.display = "initial";
          document.getElementById(this.toIdString(parent)).style.display = "inline";
        })
        Bus.$emit('vineyard-page-update', item.link);
      } else {
        this.$router.push({name: "Vineyard Page", params: {thePageId: item.link}})
      }
    },
    /*    subMenuClick(item) {
          let newPage = item;
          console.log("TabHeader: Sub Menu Go to Page: " + newPage);
          Bus.$emit('page-update', newPa);
        },
        hasSubSection: function (sectionName) {
          let hasSubsection = (sectionName !== 'LEADERSHIP_AND_ENGAGEMENT') && (sectionName !== 'STORM_AND_WASTE_WATER');
          // TODO Remove this Console Log Statement
          console.log("Has Subsection: " + hasSubsection);
          return hasSubsection;
        },*/
    tabTitle(title) {
      return `${title}`;
    },
    getUlStyles: function () {
      let style = "padding-bottom: 10px; padding-top: 10px; list-style-type: none; ";
      if (this.topLevelParent === this.sectionName) {
        style = style + "background-color: #f8f8f8;";
      }
      return style;
    },
    onEnd: function () {
      // Test
    },
    removeMe: function () {
      alert("remove me");
    }
  },
  computed: {
    canEdit: function () {
      return this.editMode;
    },
    canSave() {
      return this.modalSaveDisabled && this.selectedResponse === '';
    },
    canNext() {
      return (Object.getOwnPropertyNames(this.resolutionMap).length - 1) === this.currentResolutionNumber;
    },
  },
  mounted() {
    let self = this;
    // Menu Pull
    this.$http.get(`vineyard/5dda0499177d91260f73f35e/menu`)
        .then(result => {
          self.menu = result.data;
        }).catch(
        error => {
          console.log(error)
        });
  }
}


</script>
<style>

.nav-text {
  font-size: 20px;
  margin: 10px;
  color: black;
  cursor: pointer;
}

</style>
